import { type IncomeSplitExecution } from '@fruitful/income-split';
import { AnalyticsUserEvent } from '@fruitful/types';

import { track } from '../../../../logger/Logger';

export const trackDepositDetailsClicked = (execution: IncomeSplitExecution) => {
    track(AnalyticsUserEvent.INCOME_SPLIT_DEPOSIT_DETAILS_CLICKED, {
        executionId: execution.id,
    });
};
